<template>
  <div>
    <el-card class="searchItemFlex">
      <el-select v-model="query.id" placeholder="选择车辆" clearable filterable >
        <el-option v-for="item in carList" :key="item.id" :label="`[${item.carNum}]${item.name}`" :value="item.id"></el-option>
      </el-select>
      <el-date-picker type="year" value-format="yyyy" v-model="query.yearStr" placeholder="选择年度" clearable ></el-date-picker>
      <el-checkbox v-model="query.quarter">按季度</el-checkbox>
      <el-button type="primary" @click="getCostList">生成统计图像</el-button>
    </el-card>
      
    <el-card v-loading="loading" class="chartsContainer" element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(255, 255, 255, 0.8)">
      <div ref="MaintainCharts" class="charts" ></div>
    </el-card>
  </div>
</template>
<script>
import { carStatistic } from '@/api/cars'
import { reOrganizeMaintainCostData, getMaintainCostOption } from '../data/maintainCost'
const echarts = require("echarts")
export default {
  name: 'MaintainCost',
  props: {
    carList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      query: {
        id: null,
        yearStr: null,
        quarter: false,
        mode : 0,
      },
      costList: [],
    }
  },
  mounted() {},
  methods: {
    async getCostList() {
      this.loading = true
      const { data: res } = await carStatistic(this.query).catch(err => err)
      if (res && res.length > 0) {
        this.costList = res
        const { yAxisArr, series } = reOrganizeMaintainCostData(this.costList, this.query.quarter) 
        const option = getMaintainCostOption(yAxisArr, series)
        const myChart = echarts.init(this.$refs.MaintainCharts)
        myChart.clear()
        myChart.setOption(option)
        const _this = this
        myChart.on('click', async function (param) {
          // console.log(param);
          const conf = await _this.$confirm(`车辆【${param.seriesName}】于【${param.name}】的维保费用总额【${param.data}】元。是否前往查看该车辆维保详情？`, "提示", {
            confirmButtonText: "查看",
            cancelButtonText: "取消",
            type: "warning",
          }).catch(err => err)
          if (conf !== 'confirm') {
            return _this.$message.info('操作已取消')
          }
          _this.$store.dispatch('cars/setMaintainQueryCarNum', param.seriesName)
          _this.$router.push({ path: `/carsMaintain` })
        })
      } else {
        this.$message.warning("暂无统计数据！")
      }
      this.loading = false
    }
  },
}
</script>
<style scoped lang="less">
.chartsContainer{
  width: 100%;
  height: 650px;
  overflow: auto;
  .charts{
    width: 100%;
    height: 600px;
    overflow: auto;
  }
}
</style>
